import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=dd8365b4&lang=pug&"
import script from "./ErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports